import { render, staticRenderFns } from "./EmbedPlayer.vue?vue&type=template&id=8a5324fc&"
import script from "./EmbedPlayer.vue?vue&type=script&lang=js&"
export * from "./EmbedPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports